export const TXT_OVER = { overflowWrap: 'anywhere' };
export const TXT_CENTER = { textAlign: 'center' };
export const TXT_CENTER_OVER = { textAlign: 'center', overflowWrap: 'anywhere' }
export const TXT_LEFT= { textAlign: 'left' };
export const TXT_LEFT_OVER = { textAlign: 'left', overflowWrap: 'anywhere' };
export const TXT_RIGHT= { textAlign: 'right' };
export const TXT_RIGHT_OVER = { textAlign: 'right', overflowWrap: 'anywhere' };
export const TXT_LEFT_OVER_SPACE = { textAlign: 'left', overflowWrap: 'anywhere',whiteSpace: "pre-wrap" };
